import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";
import { AnimatePresence, type AnimationProps, motion } from "framer-motion";
import React from "react";

import { ZIndex } from "~/common/constants";

import { ConfirmationDialog, type ConfirmationDialogCloseProps } from "./confirmation-dialog";

const animationProps: AnimationProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.4 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

export function CenteredDialog({
  isOpen,
  onOpenChange,
  children,
  className,
  closeProps,
}: React.PropsWithChildren<{
  isOpen: boolean;
  onOpenChange(newIsOpen: boolean): void;
  className?: string;
  closeProps: ConfirmationDialogCloseProps;
}>) {
  return (
    <AnimatePresence>
      {isOpen ? (
        <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
          <Dialog.Portal>
            <motion.div
              {...animationProps}
              className="tw-fixed tw-inset-0 tw-z-[100]"
              style={{ zIndex: ZIndex.CENTERED_DIALOG }}
            >
              <Dialog.Overlay
                className="tw-fixed tw-inset-0 tw-bg-black/20"
                style={{ zIndex: ZIndex.CENTERED_DIALOG }}
              />

              <Dialog.Content
                className={clsx(
                  "tw-fixed tw-left-1/2 tw-top-1/2 tw-z-[100] -tw-translate-x-1/2 -tw-translate-y-1/2",
                  "tw-w-full tw-border tw-bg-white tw-p-6 tw-shadow-lg",
                  "tw-min-h-[580px] sm:tw-max-w-xl sm:tw-rounded-lg",
                )}
              >
                {className ? <div className={className}>{children}</div> : children}
                <ConfirmationDialog.Close {...closeProps} />
              </Dialog.Content>
            </motion.div>
          </Dialog.Portal>
        </Dialog.Root>
      ) : null}
    </AnimatePresence>
  );
}
